import { registerRootComponent } from "expo";
import App from "./App";
import { setupBackgroundMessaging } from "./src/services/notifications/setupBackgroundMessaging";

setupBackgroundMessaging();
registerRootComponent(App);
